import React from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  List,
  ListItem,
  Icon,
  HStack
} from '@chakra-ui/react';
import { FaCheckCircle } from 'react-icons/fa';

const AIMasteryFAQ = ({ data }) => {
  return (
    <Box py={{ base: 16, md: 20 }} bg="white">
      <Container maxW="container.lg">
        <VStack spacing={12}>
          {/* Header */}
          <VStack spacing={4} textAlign="center">
            <Heading size="2xl" fontWeight="900" color="brand.800">
              {data.title}
            </Heading>
            {data.description && (
              <Text fontSize="lg" color="brand.500" maxW="2xl">
                {data.description}
              </Text>
            )}
          </VStack>

          {/* FAQ Accordion */}
          <Accordion allowMultiple w="full">
            {data.items?.map((item, index) => (
              <AccordionItem
                key={index}
                border="none"
                mb={4}
                bg="brand.50"
                borderRadius="xl"
                overflow="hidden"
              >
                <AccordionButton
                  p={6}
                  _hover={{ bg: 'purple.50' }}
                  _expanded={{ bg: 'purple.50' }}
                >
                  <Box flex="1" textAlign="left">
                    <Text fontSize="lg" fontWeight="700" color="brand.700">
                      {item.q}
                    </Text>
                  </Box>
                  <AccordionIcon color="purple.600" boxSize={6} />
                </AccordionButton>
                <AccordionPanel p={6} pt={2} bg="white">
                  <VStack spacing={4} align="stretch">
                    <Text color="brand.600" fontSize="md" lineHeight="tall">
                      {item.a}
                    </Text>

                    {/* Real Differentiators */}
                    {item.realDifferentiators && (
                      <Box pt={2}>
                        <Text fontSize="sm" fontWeight="700" color="purple.600" mb={2}>
                          Real Differentiators:
                        </Text>
                        <List spacing={2}>
                          {item.realDifferentiators.map((diff, i) => (
                            <ListItem key={i}>
                              <HStack align="flex-start" spacing={2}>
                                <Icon as={FaCheckCircle} color="accent.green" boxSize={3} mt={1} />
                                <Text fontSize="sm" color="brand.600">{diff}</Text>
                              </HStack>
                            </ListItem>
                          ))}
                        </List>
                      </Box>
                    )}

                    {/* Specific Skills */}
                    {item.specificSkills && (
                      <Box pt={2}>
                        <Text fontSize="sm" fontWeight="700" color="purple.600" mb={2}>
                          Specific Skills You'll Learn:
                        </Text>
                        <List spacing={2}>
                          {item.specificSkills.map((skill, i) => (
                            <ListItem key={i}>
                              <HStack align="flex-start" spacing={2}>
                                <Icon as={FaCheckCircle} color="accent.green" boxSize={3} mt={1} />
                                <Text fontSize="sm" color="brand.600">{skill}</Text>
                              </HStack>
                            </ListItem>
                          ))}
                        </List>
                      </Box>
                    )}

                    {/* Value Breakdown */}
                    {item.valueBreakdown && (
                      <Box pt={2}>
                        <Text fontSize="sm" fontWeight="600" color="purple.600">
                          {item.valueBreakdown}
                        </Text>
                      </Box>
                    )}
                  </VStack>
                </AccordionPanel>
              </AccordionItem>
            ))}
          </Accordion>
        </VStack>
      </Container>
    </Box>
  );
};

export default AIMasteryFAQ;
